import { render, staticRenderFns } from "./GdDropdownButton.vue?vue&type=template&id=50365fee"
import script from "./GdDropdownButton.vue?vue&type=script&lang=js"
export * from "./GdDropdownButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports